import React from 'react';
import { ValidatorComponent } from 'react-form-validator-core';
 
class TextAreaValidator extends ValidatorComponent {
 
    render() {
        const { errorMessages, validators, requiredError, validatorListener, ...rest } = this.props;
 
        return (
            <div>
                <textarea
                    {...rest}
                    ref={(r) => { this.input = r; }}
                >{rest.value}</textarea>
                {this.errorText()}
            </div>
        );
    }
 
    errorText() {
        const { isValid } = this.state;
 
        if (isValid) {
            return null;
        }
 
        return (
            <div style={{ color: 'red' }}>
                {this.getErrorMessage()}
            </div>
        );
    }
}
 
export default TextAreaValidator;